import { useStore } from '@nanostores/react';
import { Alert } from '~/components/ui/Alert';
import { Button } from '~/components/ui/Button';
import { userStore } from '~/lib/stores/user';

export const InactiveSubscriptionBanner = ({ showPricingOverlay }: { showPricingOverlay: VoidFunction }) => {
  const user = useStore(userStore.user);

  if (!user?.featureFlags.teamManagement) {
    return null;
  }

  return (
    <Alert title="This team doesn't have an active plan" type="info" className="text-bolt-ds-brandHighlight text-sm">
      <div className="flex flex-col gap-1 items-start">
        <div className="text-bolt-ds-textSecondary text-sm">
          To manage members access, you'll need an active subscription.
        </div>
        <Button variant="link-color" color="brand" onClick={showPricingOverlay} className="mt-1">
          Choose a plan
        </Button>
      </div>
    </Alert>
  );
};
